import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class SolicitacaoDesligamentoService {

    routePrefix: string = 'Desligamento'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(id = ''): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarSolicitacao${this.routePrefix}`, { GestorId: id})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    pesquisarPorUsuarioId(usuarioId =''): Observable<any> {
      return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarSolicitacao${this.routePrefix}PorUsuarioId?usuarioId=${usuarioId}`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    solicitar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Solicitar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarTudoDesligamentoTipo(): Observable<any> {
        return this.httpClient.get<any>(`${environment.urlBase}${this.routePrefix}/BuscarTudo${this.routePrefix}Tipo`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    buscarTudoDesligamentoMotivo(): Observable<any> {
      return this.httpClient.get<any>(`${environment.urlBase}${this.routePrefix}/BuscarTudo${this.routePrefix}Motivo`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

}
